<template>
  <div class="fudongBut">
      <button class="back-to-top flicker" :class="{ 'visible': isVisible }" @click="makePhoneCall"><i class="iconfont icon-tel"></i></button>
  </div>
</template>

<script>
export default {
  name:"ContactMobile",
  data() {
    return {
      isVisible: false // 控制按钮显示/隐藏
    };
  },
  props: {
      SpgData: {
          type: Object,
          default() {  // 用函数返回默认对象
              return {};
          }
      }
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    makePhoneCall() {
      if (confirm('是否拨打' + this.SpgData.call + '？')) {
        window.location.href = 'tel:' + this.SpgData.call;
      }
    },
    // 处理滚动逻辑
    handleScroll() {
      // 滚动超过200px时显示按钮，否则隐藏
      this.isVisible = window.scrollY > 200;
    },
    // 滚动到顶部
    scrollToTop() {
      // 平滑滚动到顶部
      // window.scrollTo({
      //   top: 0,
      //   behavior: 'smooth'
      // });
    }
  },
  beforeDestroy() {
    // 移除滚动监听，避免内存泄漏
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>

.back-to-top {
  /* 固定在右下角 */
  position: fixed;
  right: 20px;
  bottom: 40px;
  cursor: pointer;
  z-index: 60;
  transition:all 300ms;
  /* 圆形按钮 */
  width: 50px;
  height: 50px;
  border-radius: 50%;
  
  /* 半透明白色背景 + 高斯模糊 */
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  
  /* 去除默认边框和样式 */
  border: none;
  padding: 0;
  margin: 0;
  
  /* 箭头样式 */
  color: #333; /* 箭头颜色 */
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* 阴影增强立体感 */
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
  
  /* 初始隐藏 */
  /* opacity: 0; */
  /* visibility: hidden; */
  
  /* 过渡动画（渐显渐隐 + 轻微缩放） */
  transition: all 0.3s ease;
  /* transform: scale(0.9); */
  /* transform: rotateX(180deg); */
  /*  -webkit-transform: rotateX(180deg); Safari 与 Chrome */
}
.back-to-top i {
	font-size: 32px;
  /* color: #e60012; */
}
.visible{
  bottom: 100px;
  transition:all 300ms;
}
.flicker {
	animation: shake 0.5s ease-in-out infinite;
}
@keyframes shake {
0%, 100% {
      transform: rotate(0deg); /* 初始和结束位置 */
}
25% {
      transform: rotate(-8deg); /* 向左旋转5度 */
}
75% {
      transform: rotate(8deg); /* 向右旋转5度 */
}
}
/* 显示状态 */
.icon-gotop1 {
	font-size: 26px;
}
/* 点击反馈 */


/* 箭头微调 */
</style>
